import "./campaignResultTopNav.scss";

export default function CampaignResultTopNav(props: {
  title?: string;
  decription?: string;
}) {
  return (
    <div className="campaign-result-top-nav">
      <div className="campaign-result-top-nav-title-container">
        <p className="campaign-result-top-nav-title">
          {props.title ?? "Loading..."}
        </p>
        <p className="campaign-result-top-nav-description">
          {props.decription ?? "Loading..."}
        </p>
      </div>
    </div>
  );
}
